import script from "./PaginatorControls.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatorControls.vue?vue&type=script&setup=true&lang=js"

import "./PaginatorControls.vue?vue&type=style&index=0&id=6de3e480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de3e480"]])

export default __exports__